import { useEffect } from 'react';
import { notification } from 'antd';

import { textToClipboard } from '../common';

// копирует содержимое тултипа по наведениию и нажатию ctrl+c
const useCopyChartTooltipData = () => {
  useEffect(() => {
    const detectPressCtrlC = (e) => {
      const code = e.which || e.keyCode;
      const charCode = String.fromCharCode(code).toLowerCase();

      if ((e.ctrlKey || e.metaKey) && charCode === 'c') {
        const charts = document.querySelectorAll('.highcharts-container');
        // eslint-disable-next-line no-restricted-syntax
        for (const chart of charts) {
          if (chart.matches(':hover')) {
            const tooltip = Array.from(chart.querySelectorAll('.highcharts-tooltip')).at(-1);
            const isTooltipHidden =
              tooltip?.style?.visibility === 'hidden' ||
              tooltip?.getAttribute('visibility') === 'hidden';

            if (tooltip && !isTooltipHidden) {
              let tooltipContent = '';

              if (tooltip.children.length > 1) {
                // если тултпип в svg, например на дашбордах
                const text = tooltip.querySelectorAll('text');
                if (text.length) {
                  text.forEach((item) => {
                    tooltipContent += item.innerHTML;
                  });
                } else {
                  // для тултипа line chart-ов с compare with period
                  tooltip.querySelectorAll('.highcharts-tooltip-box').forEach((item) => {
                    if (!item.classList.contains('highcharts-tooltip-header')) {
                      tooltipContent += item.innerHTML;
                    }
                  });
                }
              } else {
                tooltipContent = tooltip.innerHTML;
              }

              if (tooltipContent) {
                const formattedText = tooltipContent
                  // заменяем теги на пробелы
                  .replace(/<(?:"[^"]*"['"]*|'[^']*'['"]*|[^'">])+>/g, ' ')
                  // после экранирования возвращаем '->'
                  .replace(/&gt;/g, '>')
                  // оставляем только то что указано в регулярке
                  .replace(/[^a-zA-Z0-9А-Яа-яёЁ{.:,+%-_}\s]/gi, '')
                  // оставляем только один пробел
                  .replace(/\s+/g, ' ')
                  .trim();

                textToClipboard(formattedText);

                notification.success({
                  message: 'Tooltip copied',
                  duration: 3,
                  key: tooltip.textContent,
                  placement: 'bottomRight',
                  className: 'copy-tooltip-notification',
                });
              }
            }
          }
        }
      }
    };

    document.addEventListener('keydown', detectPressCtrlC);
    return () => {
      document.removeEventListener('keydown', detectPressCtrlC);
    };
  }, []);
};

export default useCopyChartTooltipData;
